import {
  cartHasGiftCards,
  getCurrency,
  getAmountTenderedByGiftCard
} from 'common/helpers/miscHelper';
import { currencyFormat } from 'common/helpers/numberHelper';

const GiftCards = (props) => {
  const { cart, settings } = props;
  if (!cartHasGiftCards(cart)) {
    return null;
  }
  const amountByGiftCard = getAmountTenderedByGiftCard(cart);
  return (
    <>
      {cart.tenders.map((tender) => (
        <GiftCard tender={tender} settings={settings} key={tender.id} />
      ))}
      <div className="c7-cart-summary__total">
        <div>Amount Due:</div>
        <div>
          <span>{getCurrency(settings)}</span>{' '}
          {currencyFormat(cart.total - amountByGiftCard, settings)}
        </div>
      </div>
    </>
  );
};

const GiftCard = (props) => {
  const { tender, settings } = props;
  if (tender.tenderType === 'Gift Card' && tender.amountTendered > 0) {
    return (
      <div>
        <div>Gift Card:</div>
        <div>{currencyFormat(tender.amountTendered, settings)}</div>
      </div>
    );
  }
  return null;
};

export default GiftCards;
